import { useDisplay } from 'vuetify'

export function useResponsiveLayout() {
  const { mobile } = useDisplay()

  return {
    mobile,
  }
}
